import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  integrationsByCategory: [],
  integrationTestingLoading: false,
  integrationDetailsToEdit: {},
  integrationDetails: {},
  integrationOptionsList: [],
  integrations: [],
  integrationsLoading: false,
  integrationListOptions: {
    sort: {
      createdDate: 'desc',
    },
    limit: 20,
    page: 1,
    search: '',
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
